import Grid from "@mui/material/Grid2";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { useEffect, useState } from "react";

interface IProps {
    files: FileNodeViewModel[];
    setSelectedFileContent: (file: string | null) => void;
}

export default function Index(props: IProps) {
    const { files, setSelectedFileContent } = props;
    const [selectedValueInSearch, setSelectedValueInSearch] = useState<string | null>();
    const [indexResults, setIndexResults] = useState<FileNodeViewModel[]>([]);

    useEffect(() => {
        setIndexResults(createIndexPageContent([...files]));
    },[files]);

   
    const createIndexPageContent = (fileList: FileNodeViewModel[]): FileNodeViewModel[] => {
        const results: FileNodeViewModel[] = [];

        for (const node of fileList) {
            if (node.fileContent !== null) {
                results.push(node);
            }
            if (node.children) {
                const childResults = createIndexPageContent(node.children);
                if (childResults.length > 0) {
                    childResults.forEach((child) => { results.push(child) });
                }
            }
        }
        return results.sort((a, b) => {
            if (a.label < b.label) return -1;
            if (a.label > b.label) return 1;
            return 0;
        });
    };

    const findItemById = (files: FileNodeViewModel[], id: string | null): void => {
        if (id == null) {
            setSelectedFileContent(null);
            return;
        }
        for (const node of files) {
            if (node.id === id) {
                if (node.fileContent !== null) {
                    setSelectedFileContent(node.fileContent);
                    setSelectedValueInSearch(node.id)
                }
                return;
            }
            if (node.children) {
                findItemById(node.children, id);
            }
        }
    };


    return (
        <Grid>
            <List dense>
                {indexResults.length > 0 && indexResults.map((node, index) => {
                    return <ListItemButton key={"indexButton" + node.id + " " + index} selected={node.id === selectedValueInSearch} onClick={() => findItemById(files, node.id)}>
                        <ListItemText key={"indextext" + node.id + " " + index} primary={node.label} />
                    </ListItemButton>;
                })}
            </List>
        </Grid>
    );
}
